<template>
  <div class="px-0">
    <v-container grid-list-md text-xs-center fluid>
      <v-layout row wrap>
        <v-flex
          xs12
          v-for="(p, indexp) in form.pasajeros"
          sm="12"
          :key="indexp"
        >
          <v-card>
            <v-card-title>
              <span
                class="title font-weight-light"
                v-html="armarDetallePasajero(p)"
              ></span>
            </v-card-title>
            <v-card-text class="headline font-weight-bold">
              <v-layout row v-if="showListPax" justify-center>
                <v-flex flex-grow>
                  <v-select
                    :items.lazy="getOptionPaxByTipo(p)"
                    label="Seleccione un pasajero | Ingrese un pasajero"
                    :id="'listPax-' + indexp"
                    v-model="p.idSeleccionado"
                    :name="'listpax-' + indexp"
                    data-vv-as="listPax"
                    @input="seleccionado(p)"
                    :ref="`paxAsing-${indexp}`"
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-layout
                wrap
                justify-space-between
                v-if="p.idSeleccionado == null"
              >
                <v-flex xs12 sm3 md2>
                  <v-text-field
                    @blur="handleBlur"
                    label="Nombre"
                    :id="'inputNombre-' + indexp + '-' + belong"
                    :error="errors.has('nombre-' + indexp + '-' + belong)"
                    data-vv-as="nombre"
                    v-model="p.nombre"
                    v-validate="'required|alpha_spaces|min:2'"
                    :name="'nombre-' + indexp + '-' + belong"
                    data-vv-delay="1500"
                    :error-messages="
                      errors.first('nombre-' + indexp + '-' + belong)
                    "
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 md2>
                  <v-text-field
                    @blur="handleBlur"
                    label="Apellido"
                    :id="'inputApellido-' + indexp + '-' + belong"
                    :error="errors.has('apellido-' + indexp + '-' + belong)"
                    v-model="p.apellido"
                    v-validate="'required|alpha_spaces|min:2'"
                    :name="'apellido-' + indexp + '-' + belong"
                    data-vv-as="apellido"
                    data-vv-delay="1500"
                    :error-messages="
                      errors.first('apellido-' + indexp + '-' + belong)
                    "
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 md2>
                  <v-text-field
                    @blur="handleBlur"
                    label="Documento"
                    type="number"
                    :id="'inputDni-' + indexp + '-' + belong"
                    :error="errors.has('dni-' + indexp + '-' + belong)"
                    v-model="p.dni"
                    v-validate="
                      'required|alpha_num|between:1000000,99999999|dni:' +
                        paxAsJson()
                    "
                    :name="'dni-' + indexp + '-' + belong"
                    data-vv-as="DNI"
                    data-vv-delay="1500"
                    :error-messages="
                      errors.first('dni-' + indexp + '-' + belong)
                    "
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 md2>
                  <v-select
                    @blur="handleBlur"
                    :items="generos"
                    :id="'inputGenero-' + indexp + '-' + belong"
                    :error="errors.has('genero-' + indexp + '-' + belong)"
                    :error-messages="
                      errors.first('genero-' + indexp + '-' + belong)
                    "
                    v-model="p.genero"
                    v-validate="'required'"
                    :name="'genero-' + indexp + '-' + belong"
                    data-vv-as="genero"
                    label="Genero"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm3 md2>
                  <v-text-field
                    @blur="handleBlur"
                    label="Fecha de nacimiento"
                    mask="##-##-####"
                    v-validate="p.vee"
                    v-model="p.nacMasked"
                    :name="'nacimiento-' + indexp + '-' + belong"
                    data-vv-as="fecha de nacimiento"
                    :error="errors.has('nacimiento-' + indexp + '-' + belong)"
                    :error-messages="
                      errors.first('nacimiento-' + indexp + '-' + belong)
                    "
                    return-masked-value
                    data-vv-delay="1500"
                    placeholder="dd-mm-yyyy"
                    @change="handleInputNacMasked(p)"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
// Si se sube el tiempo del data-vv-delay debe tambien subirse en la variable form dentro del watch, ya que ocasiona que  falla la carga de los pasajeros
// seleccionables y ocurre un error de que se relentiza el tipeo de los formularios
import moment from "moment";
import { mapGetters } from "vuex";
import { debounce } from "debounce";
export default {
  name: "pasajeros",
  components: {},
  created() {
    this.$store.dispatch("pasajeros/eliminarFormPaxToAsignar", this.belong);
  },
  mounted() {
    this.initArmarForms();
  },
  props: [
    "adls",
    "edades",
    "tipoServicio",
    "checkin",
    "belong",
    "showListPax",
    "isDisney"
  ],
  data: function() {
    return {
      form: { belong: this.belong, pasajeros: [] },
      disabledDates: [],
      fecha: moment(this.checkin),
      nacionalidades: [
        { value: "Argentino", text: "Argentino" },
        { value: "Otro", text: "Otro" }
      ],
      generos: [
        { value: 1, text: "Masculino" },
        { value: 2, text: "Femenino" }
      ],
      seleccionados: []
    };
  },
  methods: {
    initArmarForms() {
      this.armarForms(this.adls, "A", "Adulto");
      this.armarFormMenores(this.toArray(this.edades));
    },
    armarForms(cantidad, tipo, detalle) {
      for (var i = 0; i < cantidad; i++) {
        var pax = {
          id: i,
          tipo: tipo,
          detalle: detalle,
          nacionalidad: "Argentino",
          genero: null,
          idSeleccionado: null,
          nombre: null,
          apellido: null,
          dni: null,
          nacimiento: null,
          nacMasked: null,
          belong: this.belong
        };
        const dateRange = this.getValidRange(pax, i === 0);
        pax["vee"] = dateRange;
        if (process.env.NODE_ENV === "development") {
          this.prepararFake(pax);
        }
        this.form.pasajeros.push(pax);
      }
    },
    armarFormMenores(edades) {
      for (var i = 0; i < this.toArray(edades).length; i++) {
        var id = this.form.pasajeros.length;
        var pax = {
          id: id,
          tipo: "M",
          detalle: "Pasajero",
          edad: edades[i],
          nacionalidad: "Argentino",
          genero: null,
          idSeleccionado: null,
          nombre: null,
          apellido: null,
          dni: null,
          nacimiento: null,
          nacMasked: null,
          belong: this.belong
        };
        const dateRange = this.getValidRange(pax);
        pax["vee"] = dateRange;
        if (process.env.NODE_ENV === "development") {
          this.prepararFake(pax);
        }
        this.form.pasajeros.push(pax);
      }
    },
    getValidRange(pax, isPaxLead) {
      switch (pax.tipo) {
        case "M":
          return this.menorValidRange(this.fecha.clone(), parseInt(pax.edad));
        default:
          return this.adultoValidRange(this.fecha.clone(), isPaxLead);
      }
    },
    menorValidRangeHotel(fecha, edad) {
      // date_format:dd/MM/yyyy|date_between:10/09/2016,20/09/2016
      fecha.add(-edad, "years");
      var hasta = fecha.clone();
      var desde = fecha.add(-1, "years");
      const vee = {
        date_format: "dd-MM-yyyy",
        date_between: [desde.format("DD-MM-YYYY"), hasta.format("DD-MM-YYYY")],
        required: true
      };
      return vee;
    },
    menorValidRange(fecha, edad) {
      switch (this.tipoServicio) {
        case "t":
          return this.validRange(fecha, 3, 9);
        default:
          return this.menorValidRangeHotel(fecha, edad);
      }
    },
    adultoValidHotel(fecha, isPaxLead) {
      const validAge = isPaxLead ? -21 : -18;
      fecha.add(validAge, "years");
      const vee = {
        date_format: "dd-MM-yyyy",
        before: fecha.format("DD-MM-YYYY"),
        required: true
      };
      return vee;
    },
    adultoValidRange(fecha, isPaxLead) {
      switch (this.tipoServicio) {
        case "t":
          return this.validRange(fecha, 10, 100);
        default:
          return this.adultoValidHotel(fecha, isPaxLead);
      }
    },
    validRange(fecha, edadMin, edadMax) {
      let checkin = moment(fecha);
      let desde = checkin.clone().add(-edadMax, "years");
      let hasta = checkin.add(-edadMin, "years").clone();
      const vee = {
        date_format: "dd-MM-yyyy",
        date_between: [desde.format("DD-MM-YYYY"), hasta.format("DD-MM-YYYY")],
        required: true
      };
      return vee;
    },
    armarDetallePasajero(pasajero) {
      if (pasajero.tipo === "A") {
        return pasajero.detalle;
      }
      if (this.tipoServicio === "t") {
        return "Menor entre 3 a 9 años";
      }
      return (
        pasajero.detalle +
        " de " +
        pasajero.edad +
        " años para el día de entrada"
      );
    },
    seleccionado(value) {
      // SE EVALUA QUE NO SEA NULL ya que al resetear el select se vuelve a ejecutar este metodo, si es null  puede que esten desseleccionadando, en caso de ser asi se desmarca
      // de los seleccionado para que quede disponible nuevamente
      if (value.idSeleccionado === null) {
        this.seleccionados = this.seleccionados.filter(s => s.id != value.id);
        return;
      }
      this.resetInput(value);
      // Se busca el DNI del pasajero selecionado del listado para compararlos con los ingresados manualmente y evitar duplicados.
      let asignable = this.getPasajeroByBelong(value.idSeleccionado);
      let existe = this.existePasajero(asignable.dni);
      // Si hay duplicidad se resetea el select
      if (existe) {
        this.resetPaxAsingOption(value);
        this.showToasted(
          "El pasajero ya está registrado en este hotel.",
          "error"
        );
        return;
      }
      this.seleccionados.push({
        id: value.id,
        idSeleccionado: value.idSeleccionado,
        dni: asignable.dni
      });
    },
    paxAsJson: debounce(function() {
      let valid = JSON.stringify({
        pasajeros: this.form.pasajeros,
        seleccionados: this.seleccionados
      });
      return valid;
    }, 500),
    getOptionPaxByTipo: debounce(function(pax) {
      if (this.paxToAsingar.length === 0) {
        return [
          { value: null, text: "Seleccione un pasajero | Ingresar pasajero" }
        ];
      }
      let options;
      switch (pax.tipo) {
        case "A":
          options = this.getOptions(this.tipoServicio === "t" ? 9 : 18, 150); //Adultos  Hoteles, segun tipo de pasajeros All Seasons
          break;
        case "M":
          options = this.getOptions(parseInt(pax.edad), parseInt(pax.edad)); //Menores  Hoteles, segun tipo de pasajeros All Seasons
          break;
        default:
          options = [];
          break;
      }
      // Agrega item al principio del listado de pasajeros
      options.unshift({
        value: null,
        text: "Seleccione un pasajero | Ingresar pasajero"
      });
      this.$forceUpdate();
      return options;
    }, 100),
    getOptions(edadMin, edadMax) {
      // Filra los pasajeros segun la edad y que no sean del mismo servicio  a monstrar en el formulario
      var _this = this; // En el formulario crear prpieedad alterna para que sea formateada la fecha de dd-mm-yyyy a yyyy-mm-dd
      let options = [];
      this.paxToAsingar.map(function(a) {
        if (a.belong != _this.belong) {
          a.pasajeros.map(function(p) {
            let edad = _this.getEdad(p.nacimiento, _this.checkin);
            if (edad >= edadMin && edad <= edadMax) {
              let disabled = _this.seleccionados.some(
                s => a.belong + "-" + p.id === s.idSeleccionado
              );
              options.push({
                value: a.belong + "-" + p.id,
                text: p.nombre + " " + p.apellido + " DNI " + p.dni,
                disabled: disabled,
                dni: p.dni
              });
            }
          });
        }
      });
      return options;
    },
    getEdad(nacimiento, checkin) {
      var nac = moment(nacimiento);
      var cin = moment(checkin);
      let edad = cin.diff(nac, "years");
      return edad;
    },
    isFormDirty() {
      this.errors.clear("duplicidadDni");
      var _this = this;
      var estanOk = Object.keys(this.fields).every(key => {
        console.log(_this.fields[key].valid + " " + key);
        return _this.fields[key].valid;
      });
      // Confirma que la cantidad de campos a validos sean los seteados en DATA
      if (!estanOk) {
        this.eliminarFormPaxToAsignar(this.belong);
        return;
      }
      //Filtra los inputs validos
      var validos = Object.keys(this.fields).filter(
        key => _this.fields[key].valid
      );
      //Arma nombres iguales para los formularios segun el indice
      var armados = validos.map(function(item) {
        var splited = item.split("-");
        return "indice-" + splited[1];
      });

      if (!(armados.length > 0)) {
        return;
      }
      // Separa los indices de los formularios
      var indicesPasajeros = validos.map(function(item) {
        var splited = item.split("-");
        return splited[1];
      });
      // Armar los unicies sin duplicados
      var indicesUnicosPax = [...new Set(indicesPasajeros)];
      // BUsca los pasajeros segun el indice
      var oks = this.form.pasajeros.filter(function(p) {
        var esta = indicesUnicosPax.some(i => p.id == i);
        return esta ? p : null;
      });
      // validar DNI repetidos
      var form = { belong: this.belong, pasajeros: oks };
      this.$store.dispatch(
        "pasajeros/guardarPaxToAsignar",
        JSON.parse(JSON.stringify(form))
      );
    },
    resetPaxAsingOption(value) {
      // Resetea el select de los pasajeros asignables, se debe pasar el indice o el id del pasajero
      this.$refs[`paxAsing-${value.id}`][0].localValue = null;
      this.form.pasajeros[value.id].idSeleccionado = null;
    },
    getPasajeroByBelong(belong) {
      let splited = belong.split("-");
      let pasajero_id = splited.pop();
      let newBelong = splited.join("-");
      let asignables = JSON.parse(JSON.stringify(this.paxToAsingar));
      let cantidad = asignables.length;
      for (var i = 0; i < cantidad; i++) {
        if (this.paxToAsingar[i].belong === newBelong) {
          return asignables[i].pasajeros.find(p => {
            return (p.id = pasajero_id);
          });
        }
      }
      return null;
    },
    existePasajero(dni) {
      return this.form.pasajeros.some(p => parseInt(p.dni) === parseInt(dni));
    },
    resetInput(value) {
      value.nombre = null;
      value.apellido = null;
      value.dni = null;
      value.nacimiento = null;
      value.genero = null;
      value.nacionalidad = null;
    },
    handleInputNacMasked: debounce(function(pax) {
      if (pax.nacMasked.length < 10) {
        return;
      }
      pax.nacimiento = moment(pax.nacMasked, "DD-MM-YYYY").toDate();
    }, 1500),
    eliminarFormPaxToAsignar: debounce(function(belong) {
      this.$store.dispatch("pasajeros/eliminarFormPaxToAsignar", belong);
    }, 1500),
    getRamdomDNI() {
      if (process.env.NODE_ENV === "development") {
        return Math.floor(Math.random() * 2000000 + 1000000);
      }
      return null;
    },
    prepararFake(pax) {
      pax.genero = 1;
      pax.nombre = "Test";
      pax.apellido = "Test";
      pax.dni = this.getRamdomDNI();
      if (pax.vee.before != undefined) {
        let momented = moment(pax.vee.before, "DD-MM-YYYY").add(-10, "days");
        const mask = momented.format("DD-MM-YYYY");
        const odate = momented.toDate();
        pax.nacMasked = mask;
        pax.nacimiento = odate;
      }
      if (pax.vee.date_between != undefined) {
        let momented = moment(pax.vee.date_between[0], "DD-MM-YYYY").add(
          10,
          "days"
        );
        const mask = momented.format("DD-MM-YYYY");
        const odate = momented.toDate();
        pax.nacMasked = mask;
        pax.nacimiento = odate;
      }
    },
    handleBlur() {
      this.$forceUpdate();
    }
  },
  computed: {
    ...mapGetters("pasajeros", {
      paxToAsingar: "getPaxToAsingar"
    })
  },
  watch: {
    form: {
      handler: debounce(function() {
        var _this = this;
        this.$validator.validateAll().then(result => {
          if (result) {
            _this.isFormDirty();
          }
        });
      }, 1500),
      deep: true
    }
  }
};
</script>
